<ng-http-loader></ng-http-loader>
<router-outlet></router-outlet>
<!-- <ckeditor [editor]="Editor" [(ngModel)]="editorData"></ckeditor> -->